import AsyncValidations from '@/helpers/async-validations'

export default {
  model (resource) {
    return Object.assign(
      {
        firstName: '',
        secondName: '',
        maidenName: '',
        lastName: '',
        email: '',
        username: '',
        password: null,
        dealerId: null,
        branchId: null,
        role: null
      },
      resource
    )
  },
  rules (model = {}) {
    return {
      firstName: [
        { required: true, message: 'El nombre es requerido' },
        {
          min: 1,
          max: 255,
          message: 'El nombre debe ser entre 1 y 255 carácteres'
        }
      ],
      maidenName: [
        {
          min: 1,
          max: 255,
          message: 'El apellido materno debe ser entre 1 y 255 carácteres'
        }
      ],
      lastName: { required: true, message: 'El apellido paterno es requerido' },
      email: [
        {
          validator: (rule, value, callback) => {
            console.log(value)
            if (value.trim() === '') {
              callback(new Error('El email es requerido'))
            } else {
              AsyncValidations.unique('users', 'email', value)
                .then(() => {
                  callback()
                })
                .catch(e => {
                  callback(new Error(`El email "${value}" ya fue tomado`))
                })
            }
          },
          required: true,
          trigger: 'change',
          type: 'email'
        }
      ],
      username: [
        {
          validator: (rule, value, callback) => {
            if (value.trim() === '') {
              callback(new Error('El usuario es requerido'))
            } else {
              AsyncValidations.unique('users', 'username', value)
                .then(() => {
                  callback()
                })
                .catch(e => {
                  callback(new Error(`El usuario "${value}" ya fue tomado`))
                })
            }
          },
          required: true,
          trigger: 'change',
          type: 'string'
        }
      ],
      password: [
        { required: true, message: 'La contraseña es requerida' },
        {
          min: 3,
          max: 255,
          message: 'La contraseña debe ser entre 3 y 255 carácteres'
        }
      ],
      role: { required: true, message: 'Debe asignar un rol al usuario' },
      dealerId: {
        required:
          model.role === 'dealer_chief' || model.role === 'branch_chief',
        message: 'Seleccione un distribuidor'
      },
      branchId: {
        required: model.role === 'branch_chief',
        message: 'Seleccione un distribuidor'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/users/users.model.js